/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_S1Inputs */

const en_tut_audio_s1 = /** @type {(inputs: Tut_Audio_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand in an open area and press **Aktifkan mendengar** in the **Audio sekitar** panel. You hear up to three of the nearest people within six tiles.`)
};

const id_tut_audio_s1 = /** @type {(inputs: Tut_Audio_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berdirilah di area terbuka, lalu pada panel **Audio sekitar** tekan **Aktifkan mendengar**. Anda mendengar hingga tiga rekan terdekat dalam radius enam petak.`)
};

/**
* | output |
* | --- |
* | "Stand in an open area and press **Aktifkan mendengar** in the **Audio sekitar** panel. You hear up to three of the nearest people within six tiles." |
*
* @param {Tut_Audio_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_s1 = /** @type {((inputs?: Tut_Audio_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_s1(inputs)
	return en_tut_audio_s1(inputs)
});